import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { StyledBoxDay, StyledDay, StyledWeek } from './style';

const Day = ({ date, className }) => (
  <StyledBoxDay
    className={className}
    dateTime={format(date, 'YYYY-MM-DD hh:mm')}
  >
    <StyledWeek format="ddd" element="span">
      {date}
    </StyledWeek>
    <StyledDay format="DD" element="span">
      {date}
    </StyledDay>
  </StyledBoxDay>
);

Day.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string
};

export default Day;
